import { render, staticRenderFns } from "./ShipperHeader.vue?vue&type=template&id=32bc1433&scoped=true"
import script from "./ShipperHeader.vue?vue&type=script&lang=js"
export * from "./ShipperHeader.vue?vue&type=script&lang=js"
import style0 from "./ShipperHeader.vue?vue&type=style&index=0&id=32bc1433&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bc1433",
  null
  
)

export default component.exports